var map = {
	"./adult/nn/5 1 Leseforstaelse Intro.mp3": 811,
	"./adult/no/5 1 Leseforstaelse Intro.mp3": 812,
	"./child/de/5 1 Leseforstaelse Intro.mp3": 813,
	"./youth/de/5 1 Leseforstaelse Intro.mp3": 814,
	"./youth/nn/5 1 Leseforstaelse Intro.mp3": 815,
	"./youth/no/5 1 Leseforstaelse Intro.mp3": 816,
	"./youth/se/5 1 Leseforstaelse Intro.mp3": 817
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 810;